/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_AcceptInputs */

const en_ticket_action_accept = /** @type {(inputs: Ticket_Action_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept assignment`)
};

const ja_ticket_action_accept = /** @type {(inputs: Ticket_Action_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割り当てを承認`)
};

const fr_ticket_action_accept = /** @type {(inputs: Ticket_Action_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter la mission`)
};

const de_ticket_action_accept = /** @type {(inputs: Ticket_Action_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auftrag annehmen`)
};

/**
* | output |
* | --- |
* | "Accept assignment" |
*
* @param {Ticket_Action_AcceptInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_accept = /** @type {((inputs?: Ticket_Action_AcceptInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_AcceptInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_accept(inputs)
	if (locale === "ja") return ja_ticket_action_accept(inputs)
	if (locale === "fr") return fr_ticket_action_accept(inputs)
	return de_ticket_action_accept(inputs)
});